(function ($) {
  $(window).on('load', function () {
    $('.product-detail-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.product-detail-thumb'
    });
    $('.product-detail-thumb').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-detail-slider',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          }
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 3,
        //   }
        // },
      ],
    });
    $('.product-related-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: true,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        },
      ],
    });
  });
})($);